import React from 'react';

const About = () => {
    return (
        <div className="text-justify my-24 container mx-auto">
            <h1 className="text-justify my-2 tex-bold text-blue-500 text-2xl">DOCTORS PORTAL</h1>
            <span className="text-xl">We provide the best quality services for you! Just tell us about your problem, our expert doctor will solve your problem. Now connect with our doctor more easy and simpliest way. You can download our app and from there you can book your appointment. We are trying hard to to give the best support for our patients.</span> <br />

            <p className="text-xl py-5">Doctors, also known as physicians, are licensed health professionals who maintain and restore human health through the practice of medicine. They examine patients, review their medical history, diagnose illnesses or injuries, administer treatment, and counsel patients on their health and well-being.</p>

              <h1 className="text-2xl tex-semibold text-blue-600"> Our Doctor's Responsibilities:</h1>
            <p  className="text-xl py-5">

                Responding to patients’ medical problems by referring to their history, carrying out diagnosis, treatment, counseling, and referral, where necessary.
                Ordering lab tests and interpreting the test results.
                Maintaining confidentiality and impartiality at all times.
                Collecting, recording, and maintaining sensitive patient information such as examination results, medical history, and reports.
                Performing minor surgeries.
                Explaining procedures or prescribed treatments to patients.
                Liaising with medical professionals in the community and hospitals.
                Promoting health education in conjunction with other health professionals.
                Meeting targets set by the government for specified treatments, e.g. child immunization.
                Discussing and evaluating new pharmaceutical products with pharmaceutical representatives.
                Keeping up-to-date with medical developments, treatment, and medication.
                Teaching at hospitals and medical schools, and observing and assessing the work of trainee doctors and medical students.
            </p>
        </div>
    );
};

export default About;